import { SignalGraphD3 } from './signal-graph.d3';
import { type SafeAny } from '@/common/types';
import { utcFormat } from 'd3';
import { type GraphPoint } from '@/common/ui';
import { i18n, formatFixed } from '@/common/utils';
import { buildEventTooltipContent } from '@/core/helpers';

export class HeartRateSignalGraphD3 extends SignalGraphD3 {
  protected updateLine(color: string): this {
    super.updateLine(color);

    this.updateHeartRateLabels();
    return this;
  }

  protected buildTooltipContent(signalData: GraphPoint<SafeAny>): string {
    const { t } = i18n.global;

    let yData = signalData.rawY ?? signalData.y;

    if (yData.length > 1) {
      yData = yData[0] + yData[1] / 2;
    }

    const formattedY = Array.isArray(yData)
      ? yData.map((val) => formatFixed(val, 1)).join('/')
      : formatFixed(yData as number, 1);

    let tooltipHtml = `
           <p><span class='text-capitalize'>${t('time')}</span>: <strong>${utcFormat('%H:%M:%S')(new Date(signalData.x * 1000))}</strong></p>
        <p><span>${this.title}</span>: <strong>${formattedY ? `${formattedY} ${this.mapping.unit}` : 'Artifact'}</strong></p>
    `;

    if (this.activeEvent) {
      tooltipHtml += buildEventTooltipContent(this.activeEvent);
    }
    return tooltipHtml;
  }

  private updateHeartRateLabels() {
    if (!this.yScale) return;

    let data = this.data;
    data = this.getListOfLabels(data, 15);
    const { min, max } = this.getMinAndMax();
    const averageY = (min + max) / 2;
    const labels = this.graphGroup.selectAll('text.label').data(data);
    labels
      .enter()
      .append('text')
      .classed('label', true)
      .attr('x', (d) => this.xScale(d.x))
      .attr('y', averageY ? this.yScale(averageY) : '')
      .merge(labels as SafeAny)
      .attr('x', (d) => this.xScale(d.x))
      .attr('y', (d) => this.yScale(d.y))
      .attr('transform', (d) => `translate(0, ${d.y < max ? -2 : 11})`)
      .attr('text-anchor', 'middle')
      .text((d) => d.y);
    labels.exit().remove();
  }
}
